import React from 'react'
import { Button, Grid } from '@material-ui/core'
import SaveAltIcon from '@material-ui/icons/SaveAlt'
import SaveIcon from '@material-ui/icons/Save'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import { useSelector } from 'react-redux'
import { IApplicationState } from '../../../../Store'

export const FooterButtons: React.FC<{
    isLoading: boolean,
    envelopeStatus: string,
    handleDownloadPDF: () => void,
    handleSaveDraft: () => void,
    handleSign: () => void,
    handleSendToSacem: () => void,
    formIsValid: boolean
}> = ({ isLoading, envelopeStatus, handleDownloadPDF, handleSaveDraft, handleSign, handleSendToSacem, formIsValid }) => {
    const formulaire = useSelector((state: IApplicationState) => state.formulaire.fr)

    if (isLoading) {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    Loading...
                </Grid>
            </Grid>
        )
    }

    if (!envelopeStatus || envelopeStatus === '') {
        return (
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <Button
                        fullWidth
                        variant="outlined"
                        color="secondary"
                        onClick={handleDownloadPDF}
                        disabled={!formIsValid}
                    >
                        <SaveAltIcon style={{ marginRight: '7px' }} />
                        Télécharger le PDF
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button
                        fullWidth
                        variant="outlined"
                        color="secondary"
                        onClick={handleSaveDraft}
                    >
                        <SaveIcon style={{ marginRight: '7px' }} />
                        Enregistrer le brouillon
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleSign}
                        disabled={!formIsValid}
                    >
                        <DoneOutlineIcon style={{ marginRight: '7px' }} />
                        Signer ma déclaration
                    </Button>
                </Grid>
            </Grid>
        )
    } else {
        if (envelopeStatus === 'sent') {
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={handleSign}
                            disabled={!formIsValid}
                        >
                            <DoneOutlineIcon style={{ marginRight: '7px' }} />
                            Renvoyer pour signature électronique
                        </Button>
                    </Grid>
                </Grid>
            )
        }
        if (envelopeStatus === 'signed_and_sent') {
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={handleSendToSacem}
                            disabled={!formIsValid}
                        >
                            <DoneOutlineIcon style={{ marginRight: '7px' }} />
                            Renvoyer à la Sacem
                        </Button>
                    </Grid>
                </Grid>
            )
        }
        if (envelopeStatus === 'completed') {
            return (
                <Grid container>
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={handleSendToSacem}
                            disabled={!formIsValid}
                        >
                            <DoneOutlineIcon style={{ marginRight: '7px' }} />
                            Envoyer à la Sacem
                        </Button>
                    </Grid>
                </Grid>
            )
        }



        // Retour par défaut pour éviter undefined
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Button
                        fullWidth
                        variant="outlined"
                        color="secondary"
                        onClick={handleSaveDraft}
                    >
                        <SaveIcon style={{ marginRight: '7px' }} />
                        Enregistrer
                    </Button>
                </Grid>
            </Grid>
        )
    }
}
